
import {Component, Prop, Vue} from "vue-property-decorator";
import {MdbsCore} from "@/api/tsclient";
import {QueryStage} from "@/components/query/QueryStates";
import IQueryListResponse = MdbsCore.IQueryListResponse;

@Component({
  name: 'QueriesCountIcon',
  components: {},
})
export default class QueriesCountIcon extends Vue {

  @Prop({required: true})
  private queryListResponse: IQueryListResponse;

  get queries () {
    return this.queryListResponse.items ?? [];
  }

  get iconColor() {
    const allClosed = this.queries.every(q => q.stageState == QueryStage.CLOSED);
    if (allClosed)
      return "success";

    const allAnswered = this.queries.every(q => q.lastComment?.creatingUserRoleIdentifier == "Physician" ||
        q.lastComment?.creatingUserRoleIdentifier == "Nurse");
    if (allAnswered)
      return "info"

    const hasActive = !allClosed;
    if (hasActive)
      return "error";

    return "primary";
  }

  get itemsNew() {
    return this.queryListResponse.itemsNew ?? 0;
  }

  get itemsRenewed() {
    return this.queryListResponse.itemsRenewed ?? 0;
  }

  get itemsAnswered() {
    return this.queryListResponse.itemsAnswered ?? 0;
  }

  get itemsPending() {
    return this.queryListResponse.itemsPending ?? 0;
  }

  get itemsClosed() {
    return this.queryListResponse.itemsClosed ?? 0;
  }
}
